var _rect, _path, _rect2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFb = function SvgFb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 15.5,
    height: 15.5,
    rx: 7.75,
    fill: "#2E5CFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1673 10.746C13.1673 12.2627 12.2632 13.1668 10.7465 13.1668H10.2507C10.0215 13.1668 9.83398 12.9793 9.83398 12.7502V10.346C9.83398 10.2335 9.92565 10.1377 10.0381 10.1377L10.7715 10.1252C10.8298 10.121 10.8798 10.0793 10.8923 10.021L11.0382 9.22517C11.0507 9.15017 10.9923 9.07933 10.9131 9.07933L10.0256 9.09183C9.90898 9.09183 9.81732 9.00017 9.81316 8.88767L9.79649 7.86683C9.79649 7.80016 9.85065 7.74183 9.92148 7.74183L10.9215 7.72516C10.9923 7.72516 11.0465 7.671 11.0465 7.60017L11.0298 6.60016C11.0298 6.52933 10.9757 6.47516 10.9048 6.47516L9.77982 6.49183C9.08815 6.50433 8.53816 7.071 8.55066 7.76266L8.57149 8.9085C8.57565 9.02516 8.48399 9.11683 8.36732 9.121L7.86732 9.12933C7.79648 9.12933 7.74232 9.18349 7.74232 9.25432L7.75482 10.046C7.75482 10.1168 7.80898 10.171 7.87982 10.171L8.37982 10.1627C8.49649 10.1627 8.58815 10.2543 8.59231 10.3668L8.62981 12.7418C8.63398 12.9752 8.44648 13.1668 8.21315 13.1668H7.25482C5.73815 13.1668 4.83398 12.2627 4.83398 10.7418V7.25433C4.83398 5.73766 5.73815 4.8335 7.25482 4.8335H10.7465C12.2632 4.8335 13.1673 5.73766 13.1673 7.25433V10.746V10.746Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 15.5,
    height: 15.5,
    rx: 7.75,
    stroke: "#121626",
    strokeWidth: 1.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fb.682f9103.svg";
export { ForwardRef as ReactComponent };